import { render, staticRenderFns } from "./PcReports.vue?vue&type=template&id=74a51347&"
import script from "./PcReports.vue?vue&type=script&lang=js&"
export * from "./PcReports.vue?vue&type=script&lang=js&"
import style0 from "./PcReports.vue?vue&type=style&index=0&id=74a51347&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports